import { BehaviourAdapter } from '../predictive-searcher/behaviour-adapter';
import {  NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { ApiManagerService } from '@ildes/services/api-manager.service';
import { CommonModule } from '@angular/common';
import { Component, OnInit, forwardRef } from '@angular/core';
import { PredictiveSearcherComponent } from '../predictive-searcher/predictive-searcher.component';

@Component({
    selector: 'app-department-selector',
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        PredictiveSearcherComponent
    ],
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        multi: true,
        useExisting: forwardRef(() => DepartmentSelectorComponent),
      },
    ],
    template: `
      <predictive-searcher
        label="Departamento"
        [formControl]="form"
        [service]="adapter">
      </predictive-searcher>`,
    styleUrls: ['./department-selector.component.css']
})

export class DepartmentSelectorComponent extends BehaviourAdapter implements OnInit {

  constructor(
    private apiManager: ApiManagerService,
  ) {
    super();

    this.adapter = (data) => {
      return this.apiManager.getFromCatalog('department', { text: data.text});
    };
  }

  ngOnInit(): void {
    this.subscribe();
  }

}
